import React, { useEffect } from 'react';

const STYLE_ID = 'bragsheet-skeleton-styles';

function injectStyles() {
  if (document.getElementById(STYLE_ID)) return;
  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = `
    @keyframes bragsheet-skeleton-pulse {
      0% { opacity: 1; }
      50% { opacity: 0.4; }
      100% { opacity: 1; }
    }
  `;
  document.head.appendChild(style);
}

export function SkeletonBlock({ width = '100%', height = '20px', borderRadius = '6px', style = {} }) {
  useEffect(() => { injectStyles(); }, []);
  return (
    <div style={{
      width, height, borderRadius,
      backgroundColor: '#e2e8f0',
      animation: 'bragsheet-skeleton-pulse 1.5s ease-in-out infinite',
      ...style,
    }} />
  );
}

export function DashboardSkeleton({ isMobile }) {
  useEffect(() => { injectStyles(); }, []);
  return (
    <div>
      <div style={{
        display: 'grid',
        gridTemplateColumns: isMobile ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)',
        gap: '1rem',
        marginBottom: '2rem',
      }}>
        {[0, 1, 2, 3].map(i => (
          <div key={i} style={{
            backgroundColor: '#ffffff', border: '1px solid #e2e8f0',
            borderRadius: '10px', padding: '1.25rem', textAlign: 'center',
          }}>
            <SkeletonBlock width="60px" height="2rem" borderRadius="6px" style={{ margin: '0 auto 0.5rem' }} />
            <SkeletonBlock width="80px" height="0.8rem" borderRadius="4px" style={{ margin: '0 auto' }} />
          </div>
        ))}
      </div>
      <SkeletonBlock width="200px" height="1.1rem" borderRadius="6px" style={{ marginBottom: '1rem' }} />
      {[0, 1, 2].map(i => (
        <div key={i} style={{
          backgroundColor: '#ffffff', border: '1px solid #e2e8f0',
          borderRadius: '10px', padding: '1.25rem', marginBottom: '0.75rem',
        }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
            <SkeletonBlock width="60%" height="0.95rem" borderRadius="4px" />
            <SkeletonBlock width="80px" height="0.8rem" borderRadius="4px" />
          </div>
          <SkeletonBlock width="80px" height="1.4rem" borderRadius="999px" style={{ marginBottom: '0.5rem' }} />
          <SkeletonBlock width="90%" height="0.875rem" borderRadius="4px" style={{ marginBottom: '0.3rem' }} />
          <SkeletonBlock width="70%" height="0.875rem" borderRadius="4px" />
        </div>
      ))}
    </div>
  );
}
